<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ pickMode === 'multiple' ? _('Choose images') : _('Choose an image') }}</h4>
    </div>
    <div class="modal-body">
      <FileManager :pick-mode="pickMode" :max-pick="maxPick" v-on:pick="$emit('pick', $event)" v-on:close="$emit('close')" />
    </div>
  </div>
</template>

<script>
// The file library as an image picker for the editors (lib/uploadaware.js chooseFromLibrary)
export default {
  props: {
    pickMode: { type: String, default: 'single' },
    maxPick: { type: Number, default: 0 }
  },
  emits: ['pick', 'close']
}
</script>
